var map = {
	"./01_icon.svg": "cc12",
	"./05_icon.svg": "c60a",
	"./07_icon.svg": "99f0",
	"./10_icon.svg": "04ab",
	"./13_icon.svg": "0106",
	"./18_icon.svg": "f477",
	"./19_icon.svg": "5dae",
	"./20_icon.svg": "bdf3",
	"./21_icon.svg": "a7d5",
	"./30_icon.svg": "0feb",
	"./60_icon.svg": "8fb1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d10a";